const comBlur = (() => {

  const blurElem = document.querySelectorAll('.js-com-blur');
  if (blurElem.length > 0) {



    for (let i = 0; i < blurElem.length; i++) {

      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: blurElem[i],
          start: "0% 80%",
          onEnter: () => blurElem[i].classList.add('act'),
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeaveBack: () => console.log("onLeaveBack"),
          // markers: true,
        },
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    }



  }

})();
export default comBlur;